(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation_fixed"] && !Shopify.designMode) return;
  try {
    
  var headerHeight = parseInt(getComputedStyle($one('.header')).height) -1;
  var html = "";
  $$('[navigation-title]').forEach(function(element){
    var title = element.getAttribute('navigation-title');
    if(title){
      html += "<span>"+title+"</span>";
    }
  });
  if(html){
    $one('.navigation_fixed .q_pageBox-box').innerHTML = html;
    $one('.navigation_fixed').classList.add('active');
  }

  $$('.q_pageBox-box > span').forEach(function(element, index){
    element.addEventListener('click', function(event){
      var top = $$('[navigation-title]')[index].offsetTop - parseInt(getComputedStyle($one('.navigation_fixed')).height) - headerHeight;
      $$('.q_pageBox-box > span').forEach(function(el, ii){
        el.classList.remove('active');
      });
      element.classList.add('active');
      window.scrollTo(0, top);
    });
  });

  /*
  $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      for (var i = $('.target').length - 1; i >= 0; i--) {
          if (scrollTop > $('.target').eq(i).offset().top - $('.q_pageBox-nav').outerHeight(true) - 2) {
              $('.q_pageBox-box a:not(.th1Logo)').eq(i).addClass('active').siblings('a').removeClass('active');
              $('.q_pageBoxOvs').stop().animate({ scrollLeft: $('.q_pageBox-box a:not(.th1Logo)').eq(i).position().left - $(window).width() * .2 }, 100);
              return false
          }
      }
  });
  */

  const pageHeight = document.documentElement.scrollHeight;
  const viewportHeight = window.innerHeight;
  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // if (scrollTop >= viewportHeight) {
    //   $one('.navigation_fixed').classList.add('active');
    // } else {
    //   $one('.navigation_fixed').classList.remove('active');
    // }

    for (var i = $$('[navigation-title]').length - 1; i >= 0; i--) {
        if (scrollTop > $$('[navigation-title]')[i].offsetTop - parseInt(getComputedStyle($one('.navigation_fixed')).height) - headerHeight - 2) {
            $$('.q_pageBox-box > span').forEach(function(el, ii){
              el.classList.remove('active');
            });
            $$('.q_pageBox-box > span')[i].classList.add('active');
            //$('.q_pageBoxOvs').stop().animate({ scrollLeft: $('.q_pageBox-box > span')[i].position().left - $(window).width() * .2 }, 100);
            return false
        }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
